<!-- EM_MO_SB_009  일반충전 -->
<template>
    <div>
        <div class="autocharging-detail-top">
<!--            <span class="card-image shadow" :style="{ backgroundImage:'url('+$route.params.cardInfo.thumbnailImageUrl+')'}"></span>-->
          <img :src="$route.params.cardInfo.thumbnailImageUrl" alt="">
            <div class="mb-24">
                <em>{{ Number($route.params.cardInfo.remainCash).toLocaleString() }}</em>
                <strong>{{ $route.params.cardInfo.prepaidCardNickName != null? $route.params.cardInfo.prepaidCardNickName : $route.params.cardInfo.giftMessage != null? $route.params.cardInfo.giftMessage : '' }}</strong>
                <span>구매일<small>{{ $route.params.cardInfo.issueDate }}</small></span>
            </div>
        </div>
        <gray-line></gray-line>
        <div class="mb-32 pt-10 px-20">
<!--            <select-board :select-data="selectBoardList2" title="충전 금액 선택" class="mt-32"></select-board>-->
          <strong class="select-reload-notice">충전 금액 선택</strong>
          <div class="select-board select-button-box">
            <button class="cash-button" @click="selectAmount(10000, $event)">1만원<badge v-if="conditionKey && applyMinAmount <= 10000" :color="'red'" :text="'추가혜택'"></badge></button>
            <button class="cash-button" @click="selectAmount(20000, $event)">2만원<badge v-if="conditionKey && applyMinAmount <= 20000" :color="'red'" :text="'추가혜택'"></badge></button>
            <button class="cash-button" @click="selectAmount(30000, $event)">3만원<badge v-if="conditionKey && applyMinAmount <= 30000" :color="'red'" :text="'추가혜택'"></badge></button>
            <button class="cash-button" @click="selectAmount(50000, $event)">5만원<badge v-if="conditionKey && applyMinAmount <= 50000" :color="'red'" :text="'추가혜택'"></badge></button>
            <button class="cash-button" @click="selectAmount(100000, $event)">10만원<badge v-if="conditionKey && applyMinAmount <= 100000" :color="'red'" :text="'추가혜택'"></badge></button>
            <button class="cash-button" @click="selectOtherAmount($event)" @blur="checkOtherAmount()">직접입력</button>
            <input type="text" maxlength="6" v-if="isOtherAmount" name="isOtherAmount" placeholder="원"
                   ref="otherAmount"
                   @input="otherAmountBind($event)"
                   @change="checkOtherAmount()"
                   :value="otherAmount"
                   oninput="this.value = this.value.replace(/[^0-9]/ig, '')"
            />
            <bg-gray-text v-if="showBenefitAmountNotice" class="my-20" :text="`${benefitAmountNotice} 됩니다`"></bg-gray-text>
            <div v-show="amountAlertBox" :style="!amountAlertBox?'margin-left: auto; visibility:hidden':'margin-left: auto; visibility:visible'">
              <img src="@/assets/images/icon-alert.png" style="margin-right: 1px" alt="금액 입력 오류">
              <span ref="amountAlertMessage" class="amountAlertMessageBox"></span>
            </div>
          </div>
        </div>
        <gray-line></gray-line>
        <div class="pt-10">
          <div id="payment-method"></div>
        </div>
        <gray-line></gray-line>
        <div class="pt-44 pb-32 px-20">
          <div class="flex-y-center radio-wrap">
            <label class="radiobox">
              <input type="checkbox" ref="termsOfUse" class="normal-radio icon-round-check" name="normalcharging" @click="checkTermsOfUse($event)" v-model="isAgree"/>
              <span>이마티콘 이용약관(필수)</span>
            </label>
          </div>
          <div ref="termsAlertBox" style="margin-left: auto; visibility:hidden">
            <img src="@/assets/images/icon-alert.png" style="margin-right: 1px" alt="이용약관 동의 필수">
            <span ref="termsAlertMessage" class="termsAlertMessageBox">이용약관 동의는 필수 입니다.</span>
          </div>
          <div class="terms-gray-box" style="margin-top:0 !important">
            <span>이마티콘 주문 내용 및 결제조건을<br/>확인했으며, 결제진행에 동의합니다.</span>
            <button @click="showAgreePopup = true">보기</button>
            <agree-popup v-if="showAgreePopup === true" @close="showAgreePopup = false" :terms="'termsOfUse'"></agree-popup>
          </div>
        </div>
        <gray-line></gray-line>
        <div class="autocharging-precautions">
            <div>
                <span class="icon-tool-tip"></span>
                <strong>이마티콘 충전 유의사항</strong>
            </div>
            <ul>
                <li>
                    <p><span class="precautions-dot"></span><em>충전 이후 사용 이력이 없는 경우 온라인에서 구매/충전 취소가 가능합니다.</em></p>
                </li>
                <li>
                    <p><span class="precautions-dot"></span><em>온라인 충전 1회 1만원부터 최대 50만원까지 가능하며, 충전 후 총액이 50만원을 초과할 수 없습니다.</em></p>
                </li>
                <li v-if="setPrecautionsEnable()">
                  <p><span class="precautions-dot"></span><em>이마티콘은 월 최대 500만원 구매 가능합니다.<br>
                    (구매/선물/충전/자동충전 합산액 기준)<br>
                    매월 1일에 구매 가능 한도가 자동 복원됩니다.</em></p>
                </li>
            </ul>
        </div>
        <div class="bottom-sticky">
          <div class="button-wrap">
            <button ref="reloadButton" @click="clickPaymentButton('RELOAD')" class="button-bg-gray">충전하기</button>
          </div>
        </div>
<!--      <div class="autocharging-button-wrap bottom-sticky">-->
<!--        <button @click="clickPaymentButton('RELOAD',null)" class="button-bg-yellow round">구매하기</button>-->
<!--      </div>-->
    </div>
</template>

<script>
import GrayLine from '@/components/common/GrayLine.vue';
import BottomButton from '@/components/common/BottomButton.vue';
import SelectBoard from '@/components/common/SelectBoard.vue';
import SelectPayment from '@/components/common/SelectPayment.vue';
import TermsBox from '@/components/common/TermsBox.vue';
import axios from 'axios';
import apiList from "@/api/apiList";
import Badge from "@/components/common/Badge.vue";
import BgGrayText from '@/components/common/BgGrayText.vue';
import AgreePopup from "@/views/products/AgreePopup.vue";

let paymentWidget = '';
let widget = '';
export default {
  name: 'reloadCash',
  components: {GrayLine, BottomButton, SelectBoard, SelectPayment, TermsBox, Badge, BgGrayText, AgreePopup},
  data() {
    // selectBoardList: <select-board></select-board> 컴포넌트에게 전달할 프롭스
    return {
      maxCharge: Number(500000 - this.$route.params.cardInfo.remainCash), //최대 충전 가능 금액
      /** @type {String} 결제위젯 연동 키, 고유한 값으로 고정 값이다. 외부에 유출되면 안되는 정보. */
      clientKey : process.env.VUE_APP_TOSS_CLIENT_KEY,
      /** @type {String} 사용자별 고유한 id여야 한다. */
      customerKey : this.$store.state.mberInfo.mberNo,
      /** @type {Object} 주문서 생성 요청 객체 */
      prepaidCardOrderRequest: {
        /** @type {String} 고객사 번호 */
        ctmmnyNo: '',
        /** @type {String} 선불카드 번호 */
        prepaidCardNo: '',
        /** @type {String} 상품 번호 */
        goodsNo: '',
        /** @type {String} 결제 요청자 */
        paymentRequester: '',
        /** @type {String} 결제 요청자 연락처, 01033331111 양식으로 보낸다 */
        paymentRequesterContact: '',
        /** @type {String} 결제수단코드 */
        payToolCode: '',
        /** @type {String} PG코드 */
        pgCode: '',
        /** @type {Number} 원 결제금액 */
        originalAmount: 0,
        /** @type {Number} 실 결제금액 */
        paymentAmount: 0,
        /** @type {String} 결제사유
         *    ISSUE,      발급
         *     GIFT,       선불카드 선물
         *     ISSUE_VOID,    발급 취소
         *     GIFT_VOID,       선불카드 선물 취소
         *     RELOAD,      충전
         *     RELOAD_VOID    충전 취소
         */
        paymentReason: '',
        /** @type {String} 요청 채널
         *  - ONLINE: WEB/APP등 고객이 직접 신청하는 경우 - REALTIME (실시간 발급)
         *  - ADMIN: 관리자 요청 - MANUAL (매뉴얼 발급)
         *  - BATCH: 배치 - MASS (대량 발급)
         *  - EXTERNAL: 외부 요청 - EXTERNAL(외부 발급)
         * */
        requestChannel: '',
        /** @type {String} 요청자 ID */
        requestId: ''
      },
      /** @type {String} 주문 번호 */
      orderId : '',
      /** @type {Number} 원 결제금액 */
      // originalAmount: 10000,
      originalAmount: 0,
      /** @type {Number} 최종결제금액 */
      payAmount: 0,
      /** @type {Number} 혜택가 */
      benefitAmount: 0,
      /** @type {Number} 선택한 금액 */
      selectedAmount : 0,
      /** @type {String} 직접 입력한 금액
       *  직접 입력하지 않을 때, 0이면 placeholder가 사라지므로 ''(공백)으로 한다.
       */
      otherAmount : '',
      /** @type {Boolean} 직접입력 tag 사용 여부 */
      isOtherAmount : false,
      /** @type {Boolean} 이용약관 동의 값 */
      isAgree: false,
      /** @type {Boolean} 직접입력 금액값 유효성 체크 여부 */
      isCheckOtherAmount: true,
      /** @type {Object} 유효성 전체 관리 Object */
      validationObject: {
        // 초기화면에서 구매금액 10,000원이 기본적으로 선택되어 있으므로, 기본값은 true
        // amount : true,
        amount : false,
        termsOfUse : false,
      },
      amountAlertBox: false, // 최대 구매 금액은 50만원 입니다. 안내문구 노출여부
      applyMinAmount: 0,
      benefitAmountNotice:'',
      showBenefitAmountNotice:false,
      conditionKey:'',
      conditionValue:0,
      showAgreePopup: false,  //이용약관 팝업 보여주기 여부
    }
  },
  watch : {
    validationObject : {
      handler(newValue){
        if(newValue.amount && newValue.termsOfUse){
          //충전하기 버튼 활성화
          this.$refs.reloadButton.classList.remove('button-bg-gray');
          this.$refs.reloadButton.classList.add('button-bg-yellow');
        } else {
          //충전하기 버튼 비활성화
          this.$refs.reloadButton.classList.remove('button-bg-yellow');
          this.$refs.reloadButton.classList.add('button-bg-gray');
        }
      },
      deep : true
    }
  },
  mounted() {
    this.$heading('일반 충전');
    const cardInfo = this.$route.params.cardInfo;
    // prepaidCardNo가 없다면 에러페이지로 이동
    if(!cardInfo.prepaidCardNo){
      const errorPath = '/error'
      if (this.$route.path !== errorPath) {
        this.goErrorPage();
      }
      return;
    }
    // 충전 혜택 불러옴
    this.getPrepaidCardReloadBenefits();
    // 초기 진입 시 10000원으로 originalAmount 세팅하고 나머지 금액들 세팅함
    if(this.conditionKey && 10000 >= this.applyMinAmount) {
      switch (this.conditionKey) {
        case 'FIXED_RATE_EXTRA_CHARGE': // 정률 추가충전
          this.originalAmount = 10000;
          this.benefitAmount = 10000 * (100 + Number(this.conditionValue)) / 100;
          this.payAmount = 10000;
          break;
        case 'FLAT_EXTRA_CHARGE': // 정액 추가충전
          this.originalAmount = 10000;
          this.benefitAmount = 10000 + Number(this.conditionValue);
          this.payAmount = 10000;
          break;
        case 'FIXED_RATE_DISCOUNT': // 정률 할인
          this.originalAmount = 10000;
          this.benefitAmount = 10000;
          this.payAmount = 10000 * (100 - Number(this.conditionValue)) / 100;
          break;
        case 'FLAT_DISCOUNT': // 정액 할인
          this.originalAmount = 10000;
          this.benefitAmount = 10000;
          this.payAmount = 10000 - Number(this.conditionValue);
          break;
      }
    } else {
      this.originalAmount = 10000;
      this.benefitAmount = 10000;
      this.payAmount = 10000;
    }
    paymentWidget = PaymentWidget(this.clientKey, this.customerKey, {
      // 결제위젯에 브랜드페이 추가하기
      brandpay: {
        // Access Token 발급에 사용되는 리다이렉트 URL
        redirectUrl: `${process.env.VUE_APP_BACK_BASE_URL}/v1.0.0/prepaid-card/redirect-url`
      }
    })
    // 토스 위젯 렌더링
    this.renderTossWidget();
    // 충전후 총 잔액이 50만원이 넘으면 직접입력란에 자동 선택되게
    if(Number(this.benefitAmount) + Number(this.$route.params.cardInfo.remainCash) > 500000){
      const buttons = document.querySelectorAll('.cash-button');
      this.isOtherAmount = true;

      //50만원 넘으면 직접입력만 가능하게 함
      buttons.forEach(btn =>{
        btn.classList.add('selected-cash-button-disable')
      })
      buttons[0].classList.remove('selected-cash-button')
      buttons[buttons.length-1].classList.add('selected-cash-button')
      this.$refs.amountAlertMessage.innerHTML = '충전후 총액이 50만원을 초과할 수 없습니다.  <br/> 최대 구매 가능한 금액은 ' + this.maxCharge.toLocaleString() +'원 입니다.';
      // this.$refs.amountAlertBox.style.visibility = 'visible';
      this.amountAlertBox = true
    }
  },
  methods:{
    async getPrepaidCardReloadBenefits() {
      const res = await apiList.getReloadBenefits();
      const reloadBenefit = res.data.data.filter(el => !el.payToolCode)[0];
      this.conditionKey = reloadBenefit ? reloadBenefit.conditionKey : '';
      this.conditionValue = reloadBenefit ? reloadBenefit.conditionValue : 0;
      if(this.conditionKey) {
        switch (this.conditionKey) {
          case 'FIXED_RATE_EXTRA_CHARGE':
            this.benefitAmountNotice = this.conditionValue + '% 추가 충전';
            break;
          case 'FLAT_EXTRA_CHARGE':
            this.benefitAmountNotice = this.conditionValue + '원 추가 충전';
            break;
          case 'FIXED_RATE_DISCOUNT':
            this.benefitAmountNotice = this.conditionValue + '% 할인 결제';
            break;
          case 'FLAT_DISCOUNT':
            this.benefitAmountNotice = this.conditionValue + '원 할인 결제';
            break;
        }
      }
      this.applyMinAmount = reloadBenefit? reloadBenefit.applyMinAmount : 0;
      if(this.conditionKey && this.applyMinAmount <= 10000) {
        this.showBenefitAmountNotice = true;
      }
    },
    /**
     * 토스페이먼츠 결제 위젯 렌더링
     */
    renderTossWidget() {
      // 토스페이먼츠 결제 위젯 관련
      widget = paymentWidget.renderPaymentMethods(
          '#payment-method', // 토스페이먼츠를 렌더링할 태그의 id
          { value: 1000 }, //토스 현대카드 1만원 이상 할부 가능으로 1000원으로 변경
          { variantKey: 'noInstallment'} // 브랜드페이가 추가된 결제 UI의 variantKey(토스페이먼츠 홈페이지에서 rename or setting 가능)
      )
    },

    /**
     * 금액 버튼 클릭시 해당 금액을 originalAmount에 바인딩하는 메소드
     * @param {Number} selectedAmount 선택한 충전 금액
     * @param {Object} e 해당 태그의 event
     */
    selectAmount(selectedAmount, e){
      // 직접입력 tag 사용여부 false
      this.isOtherAmount = false;
      //경고 아이콘 hidden
      // this.$refs.amountAlertBox.style.visibility = 'hidden';
      // 경고문구 제거
      this.$refs.amountAlertMessage.innerHTML = '';

      // 구매금액 유효성 통과 처리
      this.validationObject.amount = true;

      // 충전금액 직접입력란 유효성 검증 통과 처리
      this.isCheckOtherAmount = true;

      // 직접 입력한 충전 금액은 ''(공백)으로 초기화
      this.otherAmount = '';
      // cash-button 클래스를 가진 노드 조회
      const buttons = document.querySelectorAll('.cash-button');
      // buttons를 순회하며 selected-cash-button 클래스가 있는지 체크 후 있으면 제거
      buttons.forEach(btn => {
       if( btn.classList.contains('selected-cash-button')){
         btn.classList.remove('selected-cash-button')
       }
      });

      // 결제가, 혜택가, 원 결제금액 세팅
      if(this.conditionKey && selectedAmount >= this.applyMinAmount) {
        switch (this.conditionKey) {
          case 'FIXED_RATE_EXTRA_CHARGE': // 정률 추가충전
            this.originalAmount = selectedAmount;
            this.benefitAmount = selectedAmount * (100 + Number(this.conditionValue)) / 100;
            this.payAmount = selectedAmount;
            break;
          case 'FLAT_EXTRA_CHARGE': // 정액 추가충전
            this.originalAmount = selectedAmount;
            this.benefitAmount = selectedAmount + Number(this.conditionValue);
            this.payAmount = selectedAmount;
            break;
          case 'FIXED_RATE_DISCOUNT': // 정률 할인
            this.originalAmount = selectedAmount;
            this.benefitAmount = selectedAmount;
            this.payAmount = selectedAmount * (100 - Number(this.conditionValue)) / 100;
            break;
          case 'FLAT_DISCOUNT': // 정액 할인
            this.originalAmount = selectedAmount;
            this.benefitAmount = selectedAmount;
            this.payAmount = selectedAmount - Number(this.conditionValue);
            break;
        }
      } else {
        this.originalAmount = selectedAmount;
        this.benefitAmount = selectedAmount;
        this.payAmount = selectedAmount;
      }
      if(Number(this.$route.params.cardInfo.remainCash) + Number(this.benefitAmount) > 500000){
        // 현잔액 + 선택한 충전금액이 50만원 넘을때
        this.$refs.amountAlertMessage.innerHTML = '충전후 총액이 50만원을 초과할 수 없습니다.  <br/> 최대 구매 가능한 금액은 ' + this.maxCharge.toLocaleString() +'원 입니다.';
        // this.$refs.amountAlertBox.style.visibility = 'visible';
        this.amountAlertBox = true
        this.otherAmount = '';
        this.originalAmount = 0;
        this.benefitAmount = 0;
        this.payAmount = 0;
        this.validationObject.amount = false;
        return
      } else {
        // 현잔액 + 선택한 충전금액이 50만원 이하일 때
        // 이벤트가 발생한 태그에 selected-cash-button 클래스 부여
        e.target.classList.add('selected-cash-button');
        // this.$refs.amountAlertBox.style.visibility = 'hidden';
        this.amountAlertBox = false
        this.$refs.amountAlertMessage.innerHTML = ''
      }

      // 추가충전 문구 노출 여부 세팅
      if(this.conditionKey && this.applyMinAmount <= selectedAmount) {
        this.showBenefitAmountNotice = true;
      } else {
        this.showBenefitAmountNotice = false;
      }
    },
    /**
     * 충전금액 직접입력 선택시 해당 금액을 payAmount에 바인딩하는 메소드
     * @param {Object} e 해당 태그의 event
     */
    selectOtherAmount(e){
      // 직접입력 tag 사용여부 false
      this.isOtherAmount = true;
      // 충전금액 직접입력란 유효성 검증 false 처리
      this.isCheckOtherAmount = false;
      // 선택한 금액은 0으로 초기화
      this.selectedAmount = 0;

      // cash-button 클래스를 가진 노드 조회
      const buttons = document.querySelectorAll('.cash-button');
      // buttons를 순회하며 selected-cash-button 클래스가 있는지 체크 후 있으면 제거
      buttons.forEach(btn => {
        if( btn.classList.contains('selected-cash-button')){
          btn.classList.remove('selected-cash-button')
        }
      });
      // 직접입력 태그에 selected-cash-button 클래스 부여
      e.target.classList.add('selected-cash-button');
      // 추가혜택 텍스트 노출 여부 초기화
      this.showBenefitAmountNotice = false;
    },

    /**
     * 충전금액을 직접 입력할때 데이터 바인딩 메소드
     * @param e 해당 태그의 event
     */
    otherAmountBind(e){
      this.otherAmount = e.target.value;
    },

    /**
     * 직접입력한 금액에 대한 유효성 검증
     */
    checkOtherAmount(){
      // 미입력 검증
      if(!this.otherAmount){
        this.otherAmount = '';
        this.originalAmount = 0;
        this.benefitAmount = 0;
        this.payAmount = 0;
        // this.$refs.amountAlertBox.style.visibility = 'visible';
        this.amountAlertBox = true
        this.$refs.amountAlertMessage.innerHTML = '금액을 입력해주세요.';
        this.validationObject.amount = false;
        return;
      }else{
        // this.$refs.amountAlertBox.style.visibility = 'hidden';
        this.amountAlertBox = false
        this.$refs.amountAlertMessage.innerHTML = '';
        this.validationObject.amount = true;
      }

      // 숫자 여부 검증
      // 콤마(,) 제거 정규식을 사용하지 않으면 "10000" 입력 후 추가로 0을 붙이면 오류(isNaN) 발생하게됨
      let otherAmount = Number(this.otherAmount.replace(/\D/g,''));
      if(isNaN(otherAmount)){
        this.otherAmount = '';
        this.originalAmount = 0;
        this.benefitAmount = 0;
        this.payAmount = 0;
        // // this.$refs.amountAlertBox.style.visibility = 'visible';
        this.amountAlertBox = true
        this.$refs.amountAlertMessage.innerHTML = '숫자만 입력 가능합니다.';
        this.validationObject.amount = false;
        return;
      }else{
        // this.$refs.amountAlertBox.style.visibility = 'hidden';
        this.amountAlertBox = false
        this.$refs.amountAlertMessage.innerHTML = '';
        this.validationObject.amount = true;
      }

      // 소수점 이하 버리기
      otherAmount = Math.floor(otherAmount);

      //payAmount(결제금액) 바인딩
      // 결제가, 혜택가, 원 결제금액 세팅
      if(this.conditionKey && otherAmount >= this.applyMinAmount) {
        switch (this.conditionKey) {
          case 'FIXED_RATE_EXTRA_CHARGE': // 정률 추가충전
            this.originalAmount = otherAmount;
            this.benefitAmount = otherAmount * (100 + Number(this.conditionValue)) / 100;
            this.payAmount = otherAmount;
            break;
          case 'FLAT_EXTRA_CHARGE': // 정액 추가충전
            this.originalAmount = otherAmount;
            this.benefitAmount = otherAmount + Number(this.conditionValue);
            this.payAmount = otherAmount;
            break;
          case 'FIXED_RATE_DISCOUNT': // 정률 할인
            this.originalAmount = otherAmount;
            this.benefitAmount = otherAmount;
            this.payAmount = otherAmount * (100 - Number(this.conditionValue)) / 100;
            break;
          case 'FLAT_DISCOUNT': // 정액 할인
            this.originalAmount = otherAmount;
            this.benefitAmount = otherAmount;
            this.payAmount = otherAmount - Number(this.conditionValue);
            break;
        }
      } else {
        this.originalAmount = otherAmount;
        this.benefitAmount = otherAmount;
        this.payAmount = otherAmount;
      }

      // 최소 금액 만족 여부 체크 (1만원 이상)
      // 24.01.02 최소 금액 변경 (10,000원 -> 10원)
      // 24.01.25 최소 금액 변경 (10원 -> 10,000원)
      if(otherAmount < 10000){
        this.otherAmount = '';
        this.originalAmount = 0;
        this.benefitAmount = 0;
        this.payAmount = 0;
        // this.$refs.amountAlertBox.style.visibility = 'visible';
        this.amountAlertBox = true
        this.$refs.amountAlertMessage.innerHTML = '최소 구매 금액은 1만원 입니다.';
        this.validationObject.amount = false;
        return;
      }else{
        this.amountAlertBox = false
        // this.$refs.amountAlertBox.style.visibility = 'hidden';
        this.$refs.amountAlertMessage.innerHTML = '';
        this.validationObject.amount = true;
      }

      // 최대 금액 만족 여부 체크 (50만원 이하만 구매 가능)
      if(otherAmount > 500000){
        this.otherAmount = '';
        this.originalAmount = 0;
        this.benefitAmount = 0;
        this.payAmount = 0;
        this.amountAlertBox = true
        // // this.$refs.amountAlertBox.style.visibility = 'visible';
        this.$refs.amountAlertMessage.innerHTML = '최대 구매 금액은 50만원 입니다. <br/> 최대 구매 가능한 금액은 ' + this.maxCharge.toLocaleString() +'원 입니다.';
        this.validationObject.amount = false;
        return;
      } else if (Number(this.$route.params.cardInfo.remainCash) + Number(this.benefitAmount) > 500000) {
        this.otherAmount = '';
        this.originalAmount = 0;
        this.benefitAmount = 0;
        this.payAmount = 0;
        this.amountAlertBox = true
        // this.$refs.amountAlertBox.style.visibility = 'visible';
        this.$refs.amountAlertMessage.innerHTML = '충전후 총액이 50만원을 초과할 수 없습니다.  <br/> 최대 구매 가능한 금액은 ' + this.maxCharge.toLocaleString() +'원 입니다.';
        this.validationObject.amount = false;
        return;
      } else {
        this.amountAlertBox = false
        // this.$refs.amountAlertBox.style.visibility = 'hidden';
        this.$refs.amountAlertMessage.innerHTML = '';
        this.validationObject.amount = true;
      }

      // 1만원 단위의 금액을 입력했는지 체크
      // 24.01.02 구매 금액 단위 변경 (10,000원 -> 10원)
      // 24.01.25 구매 금액 단위 변경 (10원 -> 10,000원)
      if(otherAmount % 10000 !== 0){
        this.otherAmount = '';
        this.originalAmount = 0;
        this.benefitAmount = 0;
        this.payAmount = 0;
        // this.$refs.amountAlertBox.style.visibility = 'visible';
        this.amountAlertBox = true
        this.$refs.amountAlertMessage.innerHTML = '1만원 단위로 충전이 가능 합니다.';
        this.validationObject.amount = false;
        return;
      } else {
        // this.$refs.amountAlertBox.style.visibility = 'hidden';
        this.amountAlertBox = false
        this.$refs.amountAlertMessage.innerHTML = '';
        this.validationObject.amount = true;
      }

      // 직접입력금액 혜택문구 노출 여부 세팅
      if(this.conditionKey && otherAmount >= this.applyMinAmount) {
        this.showBenefitAmountNotice = true;
      } else {
        this.showBenefitAmountNotice = false;
      }

      //경고 아이콘 hidden
      // this.$refs.amountAlertBox.style.visibility = 'hidden';
      this.amountAlertBox = false
      //경고 문구 제거
      this.$refs.amountAlertMessage.innerHTML = ''
      //유효성 검증 통과
      this.isCheckOtherAmount = true;
      // 직접입력란의 금액에 콤마를 찍어주기 위해서 숫자로 형변환
      this.otherAmount = otherAmount.toLocaleString(); // 천 단위 콤마

    },

    /**
     * 이용약관 동의 여부 체크시 css 속성을 수정하는 메소드
     * @param {Object} e 해당 태그의 event
     */
    checkTermsOfUse(e){
      const isAgree = e.target.checked;
      if(isAgree){
        this.$refs.termsAlertBox.style.visibility = 'hidden';
        this.validationObject.termsOfUse = true
      }
      if(!isAgree){
        this.$refs.termsAlertBox.style.visibility = 'visible';
        this.validationObject.termsOfUse = false
      }
    },
    /**
     * 결제수단 명칭을 백엔드 enum명과 동기화하는 메소드
     * @param {object} selectedPaymentMethod 고객이 선택한 결제수단
     */
    enumMatching(selectedPaymentMethod) {
      switch(selectedPaymentMethod.method) {
        case '계좌이체':
          this.prepaidCardOrderRequest.payToolCode = 'ACCOUNT_TRANSFER';
          break;
        case '간편결제':
          this.prepaidCardOrderRequest.payToolCode = 'EASY_PAY';
          break;
        default:
          this.prepaidCardOrderRequest.payToolCode = 'CARD';
      }
    },
    /**
     * 결제타입 정보를 세팅하는 함수
     * @param {object} selectedPaymentMethod 고객이 선택한 결제수단
     */
    setPaymentType(selectedPaymentMethod) {
      switch(selectedPaymentMethod.type) {
        case 'BRANDPAY':
          this.prepaidCardOrderRequest.pgCode = 'brandpay';
          break;
        default:
          this.prepaidCardOrderRequest.pgCode = 'normalpay';
      }
    },


    /**
     * 주문번호 생성 api 호출을 위한 prepaidCardOrderRequest를 세팅하는 메소드
     * @param {String} paymentReason 결제사유[발급(ISSUE),선물(GIFT) 등]
     */
    setOrderRequest(paymentReason) {
      const cardInfo = this.$route.params.cardInfo;

      this.prepaidCardOrderRequest.ctmmnyNo = this.$store.state.partnerId;
      this.prepaidCardOrderRequest.prepaidCardNo = cardInfo.prepaidCardNo;
      this.prepaidCardOrderRequest.goodsNo = cardInfo.goodsNo;
      this.prepaidCardOrderRequest.paymentReason = paymentReason;
      this.prepaidCardOrderRequest.requestChannel = 'ONLINE';
      this.prepaidCardOrderRequest.requestId = this.$store.state.mberInfo.mberNo;
    },

    /**
     * 서버에 주문번호 생성을 요청하는 메소드
     */
    setOrderIdRequestOption() {
      return {
        method: 'POST',
        url: this.$store.state.isMberPwdAuthenticated ? '/api/v1.0.0/prepaid-card/order' : '/api/v1.0.0/emarticon/order' ,
        data: {
          ...this.prepaidCardOrderRequest
        }
      };
    },
    /**
     * 구매하기 버튼 클릭시 결제를 진행하는 메소드
     * @param {String} paymentReason  결제사유[충전(RELOAD),발급(ISSUE),선물(GIFT) 등]
     */
    async clickPaymentButton(paymentReason) {
      try{

        // 충전 금액 미선택
        if(document.querySelectorAll('.selected-cash-button').length === 0) {
          return;
        }

        // 충전 금액 직접 입력을 선택했을 시, 유효성 검증을 통과했는지 체크
        if(!this.isCheckOtherAmount){
          // 미입력 검증
          if(!this.otherAmount){
            this.otherAmount = '';
            this.payAmount = 0;
            this.originalAmount = 0;
            this.benefitAmount = 0;
            this.$refs.amountAlertMessage.innerHTML = '최대 구매가능한 금액은 '+ this.maxCharge.toLocaleString() + '원 입니다' + '<br/>구매할 금액을 입력해주세요.';
            this.validationObject.amount = false;
          }

          // this.$refs.amountAlertBox.style.visibility = 'visible';
          this.$refs.otherAmount.scrollIntoView();
          return;
        }

        //충전후 총액 50만원 여부 체크
        if (Number(this.$route.params.cardInfo.remainCash) + Number(this.benefitAmount) > 500000) {
          // this.$refs.amountAlertBox.style.visibility = 'visible';
          this.$refs.otherAmount.scrollIntoView();
          return;
        }

        // 이용약관 필수동의 체크 확인
        if(!this.isAgree){
          this.$refs.termsOfUse.scrollIntoView();
          this.$refs.termsAlertBox.style.visibility = 'visible';
          return;
        }
        this.prepaidCardOrderRequest.paymentAmount = this.payAmount;
        this.prepaidCardOrderRequest.originalAmount = this.originalAmount;

        //위젯의 결제금액 update
        widget.updateAmount(this.payAmount);

        // 0. 결제수단 확인 (widget에 관한 자세한 내용은 토스페이먼츠 개발자센터 참조)
        const selectedPaymentMethod = widget.getSelectedPaymentMethod()
        // 1. 결제수단 명칭을 백엔드 enum명과 동기화
        this.enumMatching(selectedPaymentMethod);
        // 2. 결제타입 정보를 세팅
        this.setPaymentType(selectedPaymentMethod);
        // 3. API 호출을 위한 prepaidCardOrderRequest 세팅
        this.setOrderRequest(paymentReason); //ISSUE(발급)
        // 4. 서버에 주문번호(orderId) 생성 요청
        const options = this.setOrderIdRequestOption();
        const getOrderId = await axios.request(options);

        // 기간 결제금액 제한 정책 추가로 해당 부분만 분기처리, axios response 공통 수정은 영향도 이슈로 개별 처리
        if(getOrderId.status == "400" && getOrderId.code == "period.charging.amount.maximum.exceed") {
          // 기간 결제금액 제한 초과 시 메인으로 이동, 에러 데이터 메인 팝업으로 전달(메인 - showAlertPopup)
          this.$router.replace({path: '/home', query: getOrderId});
          return;
        }

        // 5. orderId 세팅
        this.orderId = getOrderId.data.data.orderNo;

        paymentWidget.requestPayment({
          orderId: this.orderId,
          orderName: this.prepaidCardOrderRequest.goodsNo,
          successUrl: `${process.env.VUE_APP_EMARTICON_SITE_DOMAIN}/product/order-result`, // 결제 승인에 사용되는 성공 리다이렉트 URL
          failUrl: `${process.env.VUE_APP_EMARTICON_SITE_DOMAIN}/home`,       // 결제 승인에 사용되는 실패 리다이렉트 URL
        }).then((response) => {console.log(response)})
            .catch((error)=> {
              console.log(error)
              // 할부박스 비활성화를 위해 결제 과정이 취소되면 1만원으로 설정(5만원 이상부터 할부 가능)
              // 다른 방법이 없었다.
              // 토스 현대카드 1만원 이상 할부 가능 케이스로 1000원으로 변경
              widget.updateAmount(1000);
            })



      } catch (error){
        const errorPath = '/error'
        if (this.$route.path !== errorPath) {
          this.goErrorPage();
        }
      }
    },
    /**
     * 에러페이지로 이동하는 함수
     */
    goErrorPage(){
      this.$router.push({ path: "/error" });
    },
    /**
     * 한도금액설정 유의사항 문구 노출
     */
    setPrecautionsEnable() {
      const today = new Date()
      const beginDate = new Date('2026-01-26T00:00:00');

      if(today > beginDate) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/cards/normalCharging.scss';
  @import '@/assets/styles/common/termsBox.scss';

  .select-reload-notice {
    display: block;
    padding-bottom: rem(16);
    @include font-size(rem(16), rem(24), 700);
    color: $color-black;
    letter-spacing: -0.8px;
  }

  .select-board {
    display: flex;
    flex-wrap: wrap;
    gap: rem(7);
    button {
      position: relative;
      width: rem(102);
      height: rem(42);
      border: 1px solid $color-gray-300;
      border-radius: rem(6);
      background-color: $color-white;
      @include font-size(rem(14), 0, 700);
      line-height: normal;
      color: $color-primary-gray;
    }
    input {
      width: 100%;
      height: rem(42);
      border: 1px solid $color-gray-300;
      border-radius: rem(6);
      &::placeholder {
        display: inline-block;
        text-align: end;
        @include font-size(rem(14), 0, 700);
        line-height: normal;
        color: $color-primary-gray;
        padding: rem(11) rem(20);
      }
    }
    .cash-button {
      width: rem(102);
    }
  }
  .select-board.select-button-box {
    gap: rem(14) rem(7);
  }

  //.cash-button {
  //  width: rem(102);
  //  height: rem(42);
  //  border: 1px solid $color-gray-300;
  //  border-radius: rem(6);
  //  background-color: $color-white;
  //  @include font-size(rem(14), 0, 700);
  //  line-height: rem(42);
  //  color: $color-primary-gray;
  //  text-align: center;
  //
  //}

  input::placeholder {
    color: #424242;
  }

  .selected-cash-button{
    //border-color: $color-primary-gray;
    border-color: $color-primary-gray !important;
  }



  .bottom-sticky {
    position: sticky;
    bottom: 0;
  }

  .amountAlertMessageBox{
    font-size:14px;
    color: #C93E5F;
  }

  .termsAlertMessageBox{
    font-size:14px;
    color: #C93E5F;
  }

  .selected-cash-button-enable{
    pointer-events: auto;
  }

  .selected-cash-button-disable{
    pointer-events: none;
  }


</style>